import React, { useEffect, useState } from "react";
import Dialog from "./Dialog";
import activeTabBar from "../../assets/images/pk-events/Rectangle.png";
import activeTabBar1 from "../../assets/images/pk-events/ic_in_room_pk_select_time_item_bg.png";
import tabBar from "../../assets/images/pk-events/Rectangle (2).png";
import tabBar1 from "../../assets/images/pk-events/image (1).png";
import backGround from "../../assets/images/pk-events/vs_resized_small.png";
import dialog from "../../assets/images/pk-events/dialog.png";
import Rectangle12 from "../../assets/images/pk-events/room_pk_dizuo2 1.png";
import star from "../../assets/images/pk-events/image 30.png";
import stars from "../../assets/images/pk-events/pretty_icon_2 1.png";
import rank1 from "../../assets/images/pk-events/family_rank_no1_ic 1.png";
import Rectangle11 from "../../assets/images/pk-events/event pk svga/pk2";
import cp_full11 from "../../assets/images/pk-events/event pk svga/pk";
import rank2 from "../../assets/images/pk-events/family_rank_no2_ic.png";
import rank3 from "../../assets/images/pk-events/family_rank_no3_ic.png";

import SVGAPlayer from "./SVGAAnimation";
import fallbackImage1 from "../../assets/icons/selected_male.png";

import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import RewardDialog from "./RewardDialog";
const Design = ({ weeklyData1, weeklyData2, weeklyData3, tops, bonusData }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen1, setIsDialogOpen1] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [activeTab1, setActiveTab1] = useState("tab4");
  const openDialog = () => setIsDialogOpen(true);
  const openDialog1 = () => setIsDialogOpen1(true);
  const closeDialog = () => setIsDialogOpen(false);
  const closeDialog1 = () => setIsDialogOpen1(false);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const [imageErrors, setImageErrors] = useState({});
  const ImageBaseUrl = "https://media.tajichat.com/";

  // Handle image error by updating the imageErrors state
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true, // Mark this item image as failed to load
    }));
  };
  const { t } = useTranslation();

  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className="w-[43%] mx-auto mt-[10px] relative">
            <SVGAPlayer
              src={Rectangle11}
              alt="background"
              height={120}
              width={170}
              className="h-[120px] z-50 relative  top-[48px] mx-auto w-[170px]"
            />
            <img
              src={
                imageErrors[tops?.winner_previous_event?.PK_king[0]?.avatar] // Check if this image has an error
                  ? fallbackImage1
                  : `${ImageBaseUrl}${tops?.winner_previous_event?.PK_king[0]?.avatar}`
              }
              onError={() =>
                handleError(tops?.winner_previous_event?.PK_king[0]?.avatar)
              } // Handle error for individual image
              alt={tops?.winner_previous_event?.PK_king[0]?.sender_id}
              className="w-[56px] h-[56px] absolute bottom-[-3px] xs:left-[58px] sm:left-[60px]  z-0 rounded-full mx-auto " // Adjust class for proper positioning
            />{" "}
            <img
              src={Rectangle12}
              alt="dialog"
              className=" absolute bottom-[-80px]"
            />{" "}
          </div>
        </div>
      );
    } else if (activeTab === "tab2") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className="w-[43%] mx-auto mt-[10px] relative">
            <SVGAPlayer
              src={Rectangle11}
              alt="background"
              height={120}
              width={170}
              className="h-[120px] z-50 relative  top-[48px] mx-auto w-[170px]"
            />
            <img
              src={
                imageErrors[tops?.winner_previous_event?.Room_pk[0]?.room_cover] // Check if this image has an error
                  ? fallbackImage1
                  : `${ImageBaseUrl}${tops?.winner_previous_event?.Room_pk[0]?.room_cover}`
              }
              onError={() =>
                handleError(tops?.winner_previous_event?.Room_pk[0]?.room_cover)
              } // Handle error for individual image
              alt={tops?.winner_previous_event?.Room_pk[0]?.roomowner_id}
              className="w-[56px] h-[56px] absolute bottom-[-3px] left-[60px]  z-0 rounded-full mx-auto " // Adjust class for proper positioning
            />{" "}
            <img
              src={Rectangle12}
              alt="dialog"
              className=" absolute bottom-[-80px]"
            />{" "}
          </div>
        </div>
      );
    } else if (activeTab === "tab3") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className="w-[43%] mx-auto mt-[10px] relative">
            <SVGAPlayer
              src={Rectangle11}
              alt="background"
              height={120}
              width={170}
              className="h-[120px] z-50 relative  top-[48px] mx-auto w-[170px]"
            />
            <img
              src={
                imageErrors[tops?.winner_previous_event?.start_pk[0]?.avatar] // Check if this image has an error
                  ? fallbackImage1
                  : `${ImageBaseUrl}${tops?.winner_previous_event?.start_pk[0]?.avatar}`
              }
              onError={() =>
                handleError(tops?.winner_previous_event?.start_pk[0]?.avatar)
              } // Handle error for individual image
              alt={tops?.winner_previous_event?.start_pk[0]?.reciver_id}
              className="w-[56px] h-[56px] absolute bottom-[-3px] left-[60px]  z-0 rounded-full mx-auto " // Adjust class for proper positioning
            />{" "}
            <img
              src={Rectangle12}
              alt="dialog"
              className=" absolute bottom-[-80px]"
            />{" "}
          </div>
        </div>
      );
    }
  };

  const renderTabContent1 = () => {
    if (activeTab1 === "tab4") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" pkRankBackground px-2 pt-[100px] mx-auto mt-[10px] w-[90%] flex flex-col  relative">
            {weeklyData1?.top.map((item, index) => (
              <div className="PKRankBackground my-1">
                <div className="flex flex-row justify-between px-3 w-full items-center h-full">
                  <div className="w-[70%] flex flex-row  items-center pt-1">
                    <p className="font-semibold w-[15%] text-lg text-[#FDF19F] font-lemon">
                      {index == 0 ? (
                        <img
                          src={rank1}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 1 ? (
                        <img
                          src={rank2}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 2 ? (
                        <img
                          src={rank3}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : (
                        index + 2
                      )}
                    </p>
                    <img
                      src={
                        imageErrors[item?.avatar] // Check if this image has an error
                          ? fallbackImage1
                          : `${ImageBaseUrl}${item?.avatar}`
                      }
                      onError={() => handleError(item?.avatar)} // Handle error for individual image
                      className={`w-16 h-16 rounded-full  
                      `}
                    />
                    <div className="w-[50%]">
                      {" "}
                      <p className="w-full  font-lemon text-[#72F3FF] text-[14px] font-normal text-start  ms-10">
                        {item?.name}
                      </p>
                      <div className="flex flex-row justify-start items-center ms-10">
                        {" "}
                        <img
                          src={stars}
                          alt="star-img"
                          className=" w-[20px]   h-[20px] "
                        />
                        <p className="w-full font-lemon text-[#01C001] text-[11px] font-normal text-start  ms-2">
                          {item?.uuid}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%] flex flex-row justify-end items-center pt-1">
                    <p className="text-shadow-[2px_2px_5px_rgba(0,0,0,0.3)] px-3 flex flex-row items-center  gap-1 text-[#66FFFF] font-mono font-semibold sm:text-[16px] xs:text-[13px]  leading-[54.32px] text-right">
                      <img
                        src={star}
                        alt="star-img"
                        className=" w-[20px]   h-[14px] "
                      />
                      {parseInt(item.totalGiftNum)}{" "}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    } else if (activeTab1 === "tab5") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" pkRankBackground px-2 pt-[100px] mx-auto mt-[10px] w-[90%] flex flex-col  relative">
            {weeklyData2?.top.map((item, index) => (
              <div className="PKRankBackground my-1">
                <div className="flex flex-row justify-between px-3 w-full items-center h-full">
                  <div className="w-[70%] flex flex-row  items-center pt-1">
                    <p className="font-semibold w-[15%] text-lg text-[#FDF19F] font-lemon">
                      {index == 0 ? (
                        <img
                          src={rank1}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 1 ? (
                        <img
                          src={rank2}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 2 ? (
                        <img
                          src={rank3}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : (
                        index + 2
                      )}
                    </p>
                    <img
                      src={
                        imageErrors[item?.avatar] // Check if this image has an error
                          ? fallbackImage1
                          : `${ImageBaseUrl}${item?.avatar}`
                      }
                      onError={() => handleError(item?.avatar)} // Handle error for individual image
                      className={`w-16 h-16 rounded-full  
                      `}
                    />
                    <div className="w-[50%]">
                      {" "}
                      <p className="w-full  font-lemon text-[#72F3FF] text-[14px] font-normal text-start  ms-10">
                        {item?.name}
                      </p>
                      <div className="flex flex-row justify-start items-center ms-10">
                        {" "}
                        <img
                          src={stars}
                          alt="star-img"
                          className=" w-[20px]   h-[20px] "
                        />
                        <p className="w-full font-lemon text-[#01C001] text-[11px] font-normal text-start  ms-2">
                          {item?.uuid}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%] flex flex-row justify-end items-center pt-1">
                    <p className="text-shadow-[2px_2px_5px_rgba(0,0,0,0.3)] px-3 flex flex-row items-center  gap-1 text-[#66FFFF] font-mono font-semibold sm:text-[16px] xs:text-[13px]  leading-[54.32px] text-right">
                      <img
                        src={star}
                        alt="star-img"
                        className=" w-[20px]   h-[14px] "
                      />
                      {parseInt(item.totalGiftNum)}{" "}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    } else if (activeTab1 === "tab6") {
      return (
        <div className="tab-panel relative  flex flex-col justify-center gap-5 items-center text-center">
          <div className=" pkRankBackground px-2 pt-[100px] mx-auto mt-[10px] w-[90%] flex flex-col  relative">
            {weeklyData3?.top.map((item, index) => (
              <div className="PKRankBackground my-1">
                <div className="flex flex-row justify-between px-3 w-full items-center h-full">
                  <div className="w-[70%] flex flex-row  items-center pt-1">
                    <p className="font-semibold w-[15%] text-lg text-[#FDF19F] font-lemon">
                      {index == 0 ? (
                        <img
                          src={rank1}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 1 ? (
                        <img
                          src={rank2}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : index == 2 ? (
                        <img
                          src={rank3}
                          alt="star-img"
                          className=" w-[30px]   h-[35px] "
                        />
                      ) : (
                        index + 2
                      )}
                    </p>
                    <img
                      src={
                        imageErrors[item?.avatar] // Check if this image has an error
                          ? fallbackImage1
                          : `${ImageBaseUrl}${item?.avatar}`
                      }
                      onError={() => handleError(item?.avatar)} // Handle error for individual image
                      className={`w-16 h-16 rounded-full  
                      `}
                    />
                    <div className="w-[50%]">
                      {" "}
                      <p className="w-full  font-lemon text-[#72F3FF] text-[14px] font-normal text-start  ms-10">
                        {item?.name}
                      </p>
                      <div className="flex flex-row justify-start items-center ms-10">
                        {" "}
                        <img
                          src={stars}
                          alt="star-img"
                          className=" w-[20px]   h-[20px] "
                        />
                        <p className="w-full font-lemon text-[#01C001] text-[11px] font-normal text-start  ms-2">
                          {item?.uuid}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="w-[25%] flex flex-row justify-end items-center pt-1">
                    <p className="text-shadow-[2px_2px_5px_rgba(0,0,0,0.3)] px-3 flex flex-row items-center  gap-1 text-[#66FFFF] font-mono font-semibold sm:text-[16px] xs:text-[13px]  leading-[54.32px] text-right">
                      <img
                        src={star}
                        alt="star-img"
                        className=" w-[20px]   h-[14px] "
                      />
                      {parseInt(item.totalGiftNum)}{" "}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
  };
  return (
    <div className="bg-[#1B0D2F] relative pkMainBackground  overflow-hidden">
      <div className="PK ">
        <Dialog
          isOpen={isDialogOpen}
          closeDialog={closeDialog}
          description={tops?.pk_event?.description}
        />{" "}
        <RewardDialog
          isOpen={isDialogOpen1}
          closeDialog={closeDialog1}
          bonusData={bonusData}
        />
        <div className="relative w-full  ">
          <img
            src={backGround}
            alt="rules"
            className="h-full relative   mx-auto w-full"
          />
          <SVGAPlayer
            src={cp_full11}
            alt="background"
            height={140}
            width={220}
            className="h-[140px] absolute top-[37%] left-1/2 transform -translate-x-1/2 mx-auto w-[220px]"
          />
          <div className="absolute top-[40%] z-[9999] right-0">
            <div
              onClick={openDialog}
              className="relative inline-block cursor-pointer"
            >
              <img
                src={dialog}
                alt="rules"
                className=" w-[75px] md:[200px] h-auto"
              />{" "}
              <p className="absolute font-rubik top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[#FFFFFF] text-base md:text-3xl font-normal leading-[48.32px] text-center">
                {t("Role")}
              </p>
            </div>
          </div>
          <div className="absolute top-[60%] z-[999]  right-0">
            <div
              onClick={openDialog1}
              className="relative inline-block cursor-pointer"
            >
              {" "}
              <img
                src={dialog}
                alt="rules"
                className=" w-[75px] md:[200px] h-auto"
              />{" "}
              <p className="absolute font-rubik top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[#FFFFFF] text-base md:text-3xl font-normal leading-[48.32px] text-center">
                {t("Reward")}
              </p>
            </div>
          </div>
        </div>{" "}
      </div>
      <div className="relative mt-[20px]  FirstTabs w-[90%] h-[240px] mx-auto ">
        <div className="flex top-12 z-[9999] relative  w-[100%] mx-auto  justify-center">
          {[
            {
              id: "tab1",
              label: "Yesterday PK King",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
            {
              id: "tab2",
              label: "Yesterday PK Room",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
            {
              id: "tab3",
              label: "Yesterday PK Star",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
          ].map((tab) => (
            <div
              key={tab.id}
              className={` inline-block relative w-[50%]  cursor-pointer ${
                activeTab == tab.id ? "active" : ""
              } `}
              onClick={() => setActiveTab(tab.id)}
            >
              <img
                src={activeTab == tab.id ? tab.imgActive : tab.imgInactive}
                alt="rules"
                className={` h-[54px]`}
              />
              <p
                className={`absolute w-full top-[60%] font-rubik font-extrabold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%]${
                  activeTab == tab.id ? " text-[#FFFFFF]" : " text-[#FFFFFF80]"
                } text-[11px] font-normal  text-center`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>
        {renderTabContent()}
      </div>
      <div className="relative   ">
        {tops?.pk_event?.remainingTime ? (
          <TimerComponent initialTime={tops?.pk_event?.remainingTime} />
        ) : null}{" "}
      </div>
      <div className="relative  mt-[20px]  w-full  mx-auto ">
        <div className="flex w-[90%] mx-auto  relative  gap-2 justify-center">
          {[
            {
              id: "tab4",
              label: "PK King",
              imgActive: activeTabBar1,
              imgInactive: tabBar1,
            },
            {
              id: "tab5",
              label: "PK Room",
              imgActive: activeTabBar1,
              imgInactive: tabBar1,
            },
            {
              id: "tab6",
              label: "PK Star",
              imgActive: activeTabBar1,
              imgInactive: tabBar1,
            },
          ].map((tab) => (
            <div
              key={tab.id}
              className={`  relative w-[32%] flex  flex-row cursor-pointer  `}
              onClick={() => setActiveTab1(tab.id)}
            >
              <img
                src={activeTab1 == tab.id ? tab.imgActive : tab.imgInactive}
                alt="rules"
                className={`w-[90%] `}
              />
              <p
                className={`absolute w-full top-1/2 font-rubik font-extrabold left-[44%] transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%]${
                  activeTab1 == tab.id ? " text-[#FFFFFF]" : " text-[#FFFFFF80]"
                } lg:text-xl md:text-base sm:text-sm xs:text-[1rem] font-normal  text-center`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>

        {renderTabContent1()}
      </div>
    </div>
  );
};

export default Design;
